// Источник истины для токенов — переменные дизайна в pencil-new.pen.
// Палитра тёмная Quanta + золото, шрифты Kodchasan (заголовки) / Rubik (текст).
// Дизайн-токены макета (семантические имена 1:1 c переменными Pencil).
export var T = {
    accent: "#FFB801",
    accentBright: "#FFE247",
    accentHover: "#E29500",
    accentTint: "rgba(255,184,1,0.12)",
    accentTintStrong: "rgba(255,184,1,0.18)",
    accentGlow: "rgba(255,231,12,0.49)",
    textPrimary: "#FFFFFF",
    textSecondary: "#C4C4C4",
    textMuted: "#95949F",
    bgPage: "#000004",
    surface: "#13131E",
    surface2: "#1B1B27",
    border: "rgba(255,255,255,0.10)",
    borderStrong: "#2A2A33",
    success: "#28C76F",
    successTint: "rgba(40,199,111,0.12)",
    danger: "#DC3545",
    dangerTint: "rgba(220,53,69,0.12)",
    info: "#3B82F6",
    infoTint: "rgba(59,130,246,0.12)",
    radius: 14,
    radiusSm: 10,
    radiusPill: 100,
};
export var FONT = {
    heading: '"Kodchasan", "Rubik", sans-serif',
    body: '"Rubik", sans-serif',
};
// Цвета сетей/блокчейнов (для бейджей в таблицах).
export var CHAIN_COLORS = {
    bsc: "#F0B90B",
    ethereum: "#627EEA",
    polygon: "#8247E5",
    solana: "#9945FF",
    base: "#0052FF",
};
// Прежний объект C сохранён без изменений: на него опираются ещё не
// переписанные экраны KYC Documents и Coin Images.
export var C = {
    bgPrimary: "#000004",
    bgSecondary: "#0d0d12",
    bgCard: "linear-gradient(145deg, #13131E 0%, #1B1B27 100%)",
    gold: "#FFB801",
    goldLight: "#FFE247",
    goldBg: "rgba(255,184,1,0.08)",
    goldBorder: "rgba(255,184,1,0.2)",
    goldBorderHover: "rgba(255,184,1,0.45)",
    textPrimary: "#fff",
    textSecondary: "rgba(255,255,255,0.55)",
    textMuted: "rgba(255,255,255,0.3)",
    divider: "rgba(255,255,255,0.07)",
    rowHover: "rgba(255,184,1,0.04)",
    successBg: "rgba(76,175,80,0.12)",
    errorBg: "rgba(244,67,54,0.12)",
};
